// extracted by mini-css-extract-plugin
module.exports = {"ellipses":"BallsStrikes_ellipses__32pbz"};